import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi700 } from "../../../../styles/font.constants";
import { BasePostStyles, BaseTitle, Text } from "../../posts.styles";

export const Post = styled.div`
	${BasePostStyles}
`;

export const Title = styled.div`
	${BaseTitle}
`;

export const Author = styled.div`
	${satoshi700}
	color: ${colours.black};
`;

export { Text, BaseTitle };
